import { gql } from "@apollo/client";

export const GET_ACCORDION_BLOCK_QUERY = gql`
  query accordionBlock($id: ID!) {
    accordionBlock(id: $id) {
      id
      defaultExpanded
      accordion_sections {
        __typename
        ... on AccordionSection {
          id
          title
          blocks {
            __typename
            ... on ComponentBlocksHtmlBlock {
              id
              html_block {
                id
                html
              }
            }
            # Include other block types that might be in accordion sections
            ... on ComponentBlocksQuestionBlock {
              question_block {
                id
                label
                type
                rows
                columns
                required
                singleLine
                question_block_answers(sort: "priority:desc") {
                  id
                  text
                }
              }
            }
            ... on ComponentBlocksDonationBlock {
              donation_block {
                id
                name
                label
                sort
                allows_any_donation_amount
                donation_style
                donation_description
                image {
                  url
                }
                donation_amounts {
                  description
                  amount
                }
                checkoutLabel
              }
            }
            ... on ComponentBlocksProductBlock {
              products_block {
                id
                header
                footer
                checkboxDisplay
                image {
                  url
                }
                products(sort: "priority:desc") {
                  id
                  fee
                  image {
                    url
                  }
                  description
                  minQuantity
                  maxQuantity
                  quantityAvailable
                  amountSold
                  product_activity_in_processes {
                    quantity
                  }
                  productActivityInProgressText
                  displayName
                  price
                  name
                }
              }
            }
            ... on ComponentBlocksMembershipComparisonBlock {
              id
              title
              subtitle
              memberships {
                name
                price
                priceDescription
                subtitle
                isBestValue
                buttonText
                product {
                  id
                  displayName
                  price
                  quantityAvailable
                  amountSold
                  productActivityInProgressText
                }
                featureValues
              }
              features {
                featureName
                featureDescription
                isHighlight
              }
            }
            ... on ComponentBlocksTwoColumnBlock {
              id
              two_column_block {
                id
              }
            }
            ... on ComponentBlocksThreeColumnBlock {
              id
              three_column_block {
                id
              }
            }
            ... on ComponentBlocksFourColumnBlock {
              id
              four_column_block {
                id
              }
            }
          }
        }
      }
    }
  }
`;
